import { Flex, Box, Button, Text } from '@chakra-ui/react'
import { FC } from 'react'

import useFollowUpReabAlert from '@hook/alerts/use-followup-reab'

import Filter from '@component/Shared/Filter'

const SupplyFilter: FC = () => {
  const {
    handleUpdateEditParams,
    loadingEdit,
    paramsEdit,
    filterEdit,
    deselectSelecteds,
    selectAllSupplys
  } = useFollowUpReabAlert()

  return (
    <Flex
      borderBottom="solid 1px"
      borderColor="gray.200"
      paddingX={4}
      paddingTop={1}
      paddingBottom={2}
    >
      <Box>
        <Text marginBottom={2}>Fornecedores</Text>

        <Filter
          label=""
          options={filterEdit.fornecedores}
          value={paramsEdit.fornecedor}
          onChange={value => {
            handleUpdateEditParams({
              name: 'fornecedor',
              value: value
            })
          }}
          isLoading={loadingEdit}
          isFollowUp={true}
          isMulti
        />
      </Box>

      <Box marginLeft={2} marginTop="28px">
        <Button
          height="38px"
          colorScheme="teal"
          variant="outline"
          onClick={selectAllSupplys}
        >
          Selecionar Todos
        </Button>
      </Box>

      <Box marginLeft={2} marginTop="28px">
        {paramsEdit.fornecedor.length > 0 ? (
          <Button
            pl={2}
            height="38px"
            colorScheme="red"
            variant="outline"
            onClick={deselectSelecteds}
          >
            Desmarcar Selecionados
          </Button>
        ) : (
          <></>
        )}
      </Box>
    </Flex>
  )
}

export default SupplyFilter
